export const passwordRecoveryDefaults = {
  password: '',
  password_confirmation: '',
};
